module.exports = __webpack_public_path__ + "static/media/Kommo-o_gaussian2.05cfbdff.png";